import { CardsScreen } from './CardsScreen.jsx';

export default {
  path: '/cards',
  element: <CardsScreen />,
  protected: true,
  permission: 'reception.view',
  standalone: false,
  sidebar: {
    label: 'البطاقات',
    icon: 'card',
    group: 'inventory',
    order: 73
  }
};
